import React from "react";
import { merge } from "lodash";
import GrComponentFactory from "../../gr_component_factory";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import UserQuoteHeader from "./user_quote_header";
import UserQuoteBody from "./user_quote_body";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "UserQuoteNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.object.isRequired,
  },

  getQuoteUser(quote) {
    return merge({}, quote.author, {
      viewableName: quote.author.name,
    });
  },

  renderBody() {
    const quote = this.props.resource.quote;
    const icon =  <UserIcon user={this.getQuoteUser(quote)} size={ICON_SIZES.LARGE}/>;

    return <SocialUpdateBody customIcon={icon}>
             <UserQuoteBody quote={quote}/>
           </SocialUpdateBody>;
  },

  getFooterLinks() {
    const quote = this.props.resource.quote;
    return [
      <a href={quote.quotesAuthorUrl} className="gr-hyperlink">
        More quotes by {quote.author.name}
      </a>,
    ];
  },

  render() {
    const header = <UserQuoteHeader quoteUrl={this.props.resource.quote.url}
                                  quoteLiked={this.props.resource.liked}/>;
    return <SocialUpdate header={header}
                         body={this.renderBody()}
                         additionalFooterLinks={this.getFooterLinks()}
                         {...this.props}/>;
  },
});
